import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { USER_TYPE } from '../../data/common';
import AddCrossIc from '../../assets/images/ic_cross.svg';
import { manualApi } from '../../api/global';
import MyManualItem from './MyManualItem';
import AddManualModal from './AddManualModal';
import ConfirmModal from '../common/ConfirmModal';
import FilterSearch from './FilterSearch';

function MyManualList({
  userType = null,
  myManuals = [],
  hoveredMyManualIdx = null,
  setHoverededMyManual,
  selectedMyManual = null,
  setSelectedMyManual,
  setMyManuals,
  reload,
}) {
  const [deleteModalOpenId, setDeleteModalOpenId] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [bookMarkList, setBookMarkList] = useState([]);

  // 나의 교재해제 버튼 클릭
  const handleRemoveMyManualClick = manual => {
    setDeleteModalOpenId(manual.idx);
  };

  // 나의 교재해제 이벤트
  const deleteMyManual = async () => {
    try {
      const myManualTarget = myManuals?.find(
        m => m.book.idx === deleteModalOpenId,
      );
      const { status } = await manualApi.deleteMyManual(myManualTarget.idx);
      if (status === 200) {
        reload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 즐겨찾기 추가
  const handleBookMarkAdd = async bookId => {
    try {
      const apiParams = {
        bookIdx: bookId,
      };
      const { status } = await manualApi.addBookmark(apiParams);
      if (status === 200) {
        reload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 즐겨찾기 리스트 로드
  useEffect(() => {
    (async () => {
      try {
        if (myManuals?.length < 1) return;
        const { data } = await manualApi.getBookmarkList();
        setBookMarkList(data.favorites);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [myManuals]);

  // 즐겨찾기 해제
  const handleBookMarkRemove = async manualIdx => {
    try {
      const { status } = await manualApi.removeBookmark(manualIdx);
      if (status === 200) {
        reload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 내교재 마우스 호버
  const handleMyManualHover = manual => {
    setHoverededMyManual(manual);
  };

  return (
    <div className="w-full h-full flex flex-col items-start justify-center overflow-hidden">
      <div className="relative flex flex-col w-full h-full bg-[#F1F5F9] py-[16px] items-start justify-start">
        <div
          className="mb-[20px] w-full flex gap-1 h-[40px] justify-start items-center px-[30px]"
          style={{
            justifyContent:
              userType === USER_TYPE.STUDENT ? 'space-between' : 'flex-start',
          }}
        >
          {userType === USER_TYPE.STUDENT && (
            <div className="font-[700] text-[16px]">
              <span>나의 교재</span>&nbsp;
              <span className="text-[#0AAAED]">{myManuals?.length}권</span>
            </div>
          )}
          <FilterSearch
            location="my"
            setManuals={setMyManuals}
            reload={reload}
          />
        </div>
        <div
          className="grow w-full overflow-y-scroll grid grid-cols-4 gap-y-[40px] gap-x-[12px] px-[30px] justify-center items-start"
          style={{
            gridTemplateColumns:
              selectedMyManual !== null ? 'repeat(4, 1fr)' : 'repeat(7, 1fr)',
            gridTemplateRows: 'minmax(300px, 300px)',
          }}
        >
          {userType === USER_TYPE.STUDENT && (
            <div className="border flex flex-col items-center justify-center">
              <Button
                className="w-[152px] h-[198px] flex relative grow flex justify-center items-center cursor-pointer"
                style={{ backgroundColor: '#E2E8EF' }}
                onClick={() => setAddModalOpen(true)}
              >
                <img src={AddCrossIc} alt="add" />
              </Button>
              <div className="w-full h-[40px] flex justify-center items-center">
                교재 추가하기
              </div>
            </div>
          )}
          {myManuals?.length >= 1 &&
            myManuals?.map(manual => {
              const isFavored = bookMarkList.some(
                item => item.book.idx === manual.book_idx,
              );
              return (
                <MyManualItem
                  key={manual.idx}
                  manual={manual?.book}
                  myManuals={myManuals}
                  selectedMyManual={selectedMyManual}
                  hoveredMyManualIdx={hoveredMyManualIdx}
                  setSelectedMyManual={setSelectedMyManual}
                  onRemoveMyManualClick={handleRemoveMyManualClick}
                  onManualHover={handleMyManualHover}
                  onManualLeave={() => setHoverededMyManual(null)}
                  onBookMarkAdd={handleBookMarkAdd}
                  onBookMarkRemove={handleBookMarkRemove}
                  isFavored={isFavored}
                />
              );
            })}
        </div>
        {myManuals?.length < 1 && (
          <div
            className="absolute top-[50%] left-[50%] flex justify-center items-center text-[#383C4B] font-[16px] font-[400]"
            style={{ transform: 'translate(-50%, -50%)' }}
          >
            {JSON.parse(sessionStorage.getItem('ceduMyManuals')) > 0
              ? '검색 결과가 없습니다.'
              : '[전체 교재]에서 나의 교재를 추가해 주세요.'}
          </div>
        )}
      </div>
      <ConfirmModal
        open={deleteModalOpenId === null ? false : true}
        setOpen={setDeleteModalOpenId}
        content={`나의 교재에서 삭제됩니다.\n삭제 시 저장된 시험지 목록도 함께 삭제됩니다.\n정말 삭제하시겠습니까?`}
        cancelLabel="취소"
        confirmLabel="삭제"
        onCancel={() => setDeleteModalOpenId(null)}
        onConfirm={deleteMyManual}
      />
      <AddManualModal
        open={addModalOpen}
        setOpen={setAddModalOpen}
        reload={reload}
      />
    </div>
  );
}

MyManualList.propTypes = {
  userType: PropTypes.number,
  myManuals: PropTypes.arrayOf(PropTypes.object),
  hoveredMyManualIdx: PropTypes.number,
  setHoverededMyManual: PropTypes.func.isRequired,
  selectedMyManual: PropTypes.object,
  setSelectedMyManual: PropTypes.func.isRequired,
  setMyManuals: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
};

export default MyManualList;
